var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SuccessWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2c-5.51397,0 -10,4.48604 -10,10c0,5.51396 4.48603,10 10,10c5.51397,0 10,-4.48604 10,-10c0,-5.51396 -4.48603,-10 -10,-10zM12,3.5c4.70331,0 8.5,3.7967 8.5,8.5c0,4.7033 -3.79669,8.5 -8.5,8.5c-4.70331,0 -8.5,-3.7967 -8.5,-8.5c0,-4.7033 3.79669,-8.5 8.5,-8.5zM16.24805,8.98047c-0.19478,0.00568 -0.3797,0.08693 -0.51562,0.22656l-4.73242,4.73047l-2.72461,-2.72266c-0.18811,-0.19592 -0.46745,-0.27485 -0.73028,-0.20633c-0.26283,0.06852 -0.46808,0.27377 -0.5366,0.5366c-0.06852,0.26283 0.0104,0.54216 0.20633,0.73028l3.25391,3.25586c0.14074,0.1412 0.33189,0.22056 0.53125,0.22056c0.19936,0 0.39051,-0.07936 0.53125,-0.22056l5.26172,-5.26367c0.22145,-0.21567 0.28791,-0.54512 0.16739,-0.82978c-0.12052,-0.28466 -0.40332,-0.46623 -0.71232,-0.45733z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SuccessWhite);
export default __webpack_public_path__ + "static/media/icons8-success-white.57150ac7bdd09fa17b8782140025c31b.svg";
export { ForwardRef as ReactComponent };